import React, { Component } from 'react';
import { Icon, translate } from '@haldor/ui';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import User from '_class/User';

import { getUserInfo } from 'actions/user';
import { getVerdictScale, updateVerdict, deleteVerdict } from 'actions/verdicts';

import VerdictForm from 'containers/Verdict/Form/VerdictForm';

import VerdictDisplayFeedback from './Partials/VerdictDisplayFeedback';
import VerdictDisplayLevel from './Partials/VerdictDisplayLevel';
import { Button } from '@haldor/ui';

class VerdictDisplay extends Component {
	constructor(props) {
		super(props);

		this.state = {
			edit: false,
			user: new User(this.props.currentUser)
		}
	}

	componentDidMount = () => {
		if (this.props.scale == null) {
			this.props.getVerdictScale();
		}

		if (this.getUser() == null) {
			this.props.getUserInfo(this.props.verdict.editor, 'base');
		}
	}

	getUser = () => {
		let user = this.props.users.find(user => {
			return user.userId == this.props.verdict.editor;
		});

		return user;
	}

	deleteVerdictPublished = (verdict) => {
		Swal.fire({
			title: this.props.translate('are-you-sure'),
			text: this.props.translate('are-you-sure-you-want-to-delete'),
			showCancelButton: true,
			cancelButtonText: this.props.translate('No'),
			confirmButtonText: this.props.translate('Yes'),
		}).then(result => {
			if (result.isConfirmed) {
				if (this.props.setLoading) {
					this.props.setLoading(true);
				}

				this.props.deleteVerdict(verdict.id).then(() => {
					if (this.props.reload != null) {
						this.props.reload();
					}
				});
			}
		});
	}

	deleteVerdictForm = (verdict) => {
		this.setState({ loading: true });

		if (this.props.setLoading) {
			this.props.setLoading(true);
		}

		this.props.deleteVerdict(verdict.id).then(() => {
			if (this.props.reload != null) {
				this.props.reload();
			}
		});
	}

	onVerdictFormSubmit = (values) => {
		return new Promise((resolve) => {
			values.userId = this.props.verdict.userId;
			values.courses = [{
				"courseCode": this.props.course.courseCode,
				"subjectCode": this.props.course.subjectCode,
				"courseID": (this.props.course.id != null && this.props.course.id !== 0)
					? this.props.course.id
					: this.props.course.courseID
			}];

			this.props.updateVerdict(values).then(() => {
				this.setState({ edit: false });
				if (this.props.reload != null) {
					this.props.reload();
				}

				resolve(1);
			})
		});
	}

	render() {
		if (this.props.verdict == null) {
			return null;
		}

		const user = new User(this.props.currentUser);
		const course = this.props.course;

		return (
			<div className="verdict verdict-display-container">
				{this.props.scale != null && !this.state.edit ?
					<VerdictDisplayLevel
						verdict={this.props.verdict}
						scale={this.props.scale}
					/>
					: null}

				<div className="display-feedback-container">
					{!this.state.edit ? <div>
						<VerdictDisplayFeedback
							verdict={this.props.verdict}
							user={this.getUser()}
						/>

						{user.isTeacher() && <>
							<div className="permission" style={{ marginTop: '1.35rem', marginLeft: '0rem' }}>
								<Icon name={this.props.verdict.visibleToGuardiansAndStudents ? "Eye" : "Eye_Off"} />
								{this.props.verdict.visibleToGuardiansAndStudents ?
									this.props.translate("Shown to students and parents") :
									this.props.translate("Hidden from students and parents")}
							</div></>}
					</div>
						: null}

					{this.state.edit ?
						<VerdictForm
							verdict={this.props.verdict}
							deleteVerdict={this.deleteVerdictForm}
							onSubmit={this.onVerdictFormSubmit}
							edit={this.state.edit}
							group={this.props.group}
							courseId={course.Id}
						/>
						: null}
				</div>
				{!this.props.isStudent && (!this.props.group || !this.props.group.archived) && user.isTeacher() ?
					<Button
						style={{ float: 'right', marginTop: '1em' }}
						type="secondary"
						onClick={(e) => { e.preventDefault(); this.setState({ edit: this.state.edit ? false : true }) }}
					>
						{this.state.edit ? this.props.translate('close') : this.props.translate('Edit')}
					</Button>
					: null}

				{!this.props.isStudent && (!this.props.group || !this.props.group.archived) && (user.isAdministrator() || user.data.id == this.props.verdict.creator) ?
					<Button
						style={{ float: 'right', marginTop: '1em', marginRight: '0.5rem' }}
						type="secondary"
						onClick={(e) => { e.preventDefault(); this.deleteVerdictPublished(this.props.verdict) }}
					>
						{this.props.translate('Delete')}
					</Button>
					: null}


				<div style={{ clear: 'both' }}></div>
			</div>
		);
	}

}

function mapStateToProps(state) {
	return {
		translate: translate(state.Languages.translations),
		scale: state.Verdicts.scale,
		currentUser: state.user.currentUser,
		users: state.user.info,
	};
}

export default connect(mapStateToProps, {
	getVerdictScale,
	getUserInfo,
	updateVerdict,
	deleteVerdict
})(VerdictDisplay);
